package com.appcreator.blueprint.firebase.storage

import com.appcreator.blueprint.core.Action
import com.appcreator.blueprint.core.ActionClass
import com.appcreator.blueprint.core.InputProperty
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
@SerialName("FirebaseStorageDeleteAction")
@ActionClass(
    group = FirebaseStorageConsts.group,
    title = "Delete File",
    isExtraPlugin = true,
    availableFrom = "0.0.1"
)
class FirebaseStorageDeleteAction(
    @InputProperty(
        title = "File Path",
        availableFrom = "0.0.1"
    )
    val path: String?,
): Action
